<div class="ticket-container state-warning" [class.light]="isLight" [class.dark]="!isLight">
  <div class="main-info-wrapper">
    <div class="main-info gap-3">
      <div class="icon">
        <app-icam-icon [iconName]="'warning'" [isDefault]="true" iconHeight="35px" />
      </div>
      <div>
        <h2 class="title fw-semibold my-0 py-0 title-warning">
          <span>{{ 'TICKET.WARNING' | translate }}: </span>
          <span>{{ 'TICKET.CONTRACT' | translate }} {{ 'TICKET.' + contract.state | translate }}</span>
        </h2>
      </div>
    </div>
    <div class="error-or-date pt-2">
      <span class="fw-semibold">{{ 'TICKET.EXPIRING_DATE' | translate }}: </span>
      {{ contract.endDate | date }}
    </div>
  </div>
  <div class="details-container">
    <div>
      <span class="fw-semibold">{{ 'TICKET.CONTRACT_DATA' | translate }} </span>
    </div>
    <div class="details">
      <div class="contract-name ticket-info-first">
        <span class="fw-semibold">{{ 'TICKET.NAME' | translate }}: </span>{{ contract.contractName }}
      </div>
      <div class="contract-name ticket-info px-3">
        <span class="fw-semibold">{{ 'TICKET.NUMBER' | translate }}: </span>{{ contract.serialNumber }}
      </div>
    </div>
  </div>

  <div class="button-container">
    <button
      class="btn-warning"
      *appHasRole="['CUSTOMER', 'CUSTOMER_PARTNER', 'PARTNER', 'ADMIN']"
      [ngClass]="isLight ? 'light' : 'dark'"
      [routerLink]="['/request', 'new']"
      [queryParams]="{ serialNumber: contract.serialNumber, description: contract.contractName }"
    >
      {{ 'TICKET.INFORMATION' | translate }}
    </button>
  </div>
</div>
